import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import { TiUserAdd } from "react-icons/ti";
import { WiTime3 } from "react-icons/wi";

const ManageInvitations = () => {
  const [value, setValue] = React.useState("1");
  const [invitationcount, setInvitationCount] = useState("");
  const [sendRequests, setSendRequests] = useState([]);
  const [recievedRequests, setRecievedRequests] = useState([]);
  const tabs = [
    { label: "Recieved", value: "1" },
    { label: "Sent", value: "2" },
  ];
  useEffect(() => {
    getSendRequests();
    getRecievedRequests();
  }, []);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getColorFromName = (name) => {
    if (!name) return { backgroundColor: "hsl(0, 0%, 50%)" };
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    const saturation = 70 + (Math.abs(hash) % 30); // 70–99%
    const lightness = 50 + (Math.abs(hash) % 10);
    return {
      backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
    };
  };

  const getSendRequests = async () => {
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getsendrequests", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setSendRequests(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const getRecievedRequests = async () => {
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getrecievedrequests", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setRecievedRequests(result.data.data);
        setInvitationCount(result.data.data.length);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleAccept = async (id) => {
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await axios.post(BaseUrl + `acceptrequest`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        getRecievedRequests();
        getData();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDecline = async (id) => {
    const token = Cookies.get("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await axios.post(BaseUrl + `rejectrequest`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        getSendRequests();
        getData();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="bg-[#F3F2EF] mt-10 min-h-screen ">
      <div className="container mx-auto flex flex-col lg:flex-row gap-4 py-4 px-4  sm:px-6 lg:px-8">
        <div className="w-full lg:w-3/4 ">
          <div className="bg-white border border-gray-300 rounded-lg shadow mb-4">
            <div className=" py-2">
              <div>
                <h2 className="text-lg text-gray-700 font-thin px-4">
                  Manage invitations
                </h2>
              </div>
              <div className="flex">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="Dynamic Tabs Example"
                        textColor="primary"
                        indicatorColor="primary"
                      >
                        {tabs.map((tab) => (
                          <Tab
                            key={tab.value}
                            label={tab.label}
                            value={tab.value}
                            sx={{
                              color:
                                value === tab.value ? "#1976D2" : "#757575",
                              fontWeight:
                                value === tab.value ? "bold" : "normal",
                              fontSize: "16px",
                              mx: 2,
                              textTransform: "capitalize",
                              // borderBottom: value === tab.value ? "3px solid green" : "none",
                              // "&.Mui-selected": {
                              //   color: "green",
                              // },
                              "&:hover": {
                                backgroundColor: "#F3F4F6",
                              },
                            }}
                          />
                        ))}
                      </TabList>
                    </Box>

                    <TabPanel value="1">
                      {recievedRequests && recievedRequests.length > 0 ? (
                        <div>
                          {recievedRequests.map((request, index) => (
                            <div
                              key={index}
                              className="flex justify-between px-4 border-b border-gray-200 "
                            >
                              <div className="flex items-center gap-4">
                                <Link to={`/user/profile/${request.slug}`}>
                                  {request.profile ? (
                                    <img
                                      src={request.profile}
                                      alt={request.name}
                                      className="w-12 h-12 rounded-full object-cover"
                                    />
                                  ) : (
                                    <div
                                      className="w-12 h-12 rounded-full  text-white flex items-center justify-center font-semibold text-lg"
                                      style={getColorFromName(
                                        request.name || "?"
                                      )}
                                    >
                                      {request.name.charAt(0)}
                                    </div>
                                  )}
                                </Link>
                                <Link
                                  to={`/user/profile/${request.slug}`}
                                  className=""
                                >
                                  <p className="text-gray-800 text-lg font-semibold">
                                    {request.name}
                                  </p>
                                  <p className="text-gray-500">
                                    {request.headline}
                                  </p>
                                  {request.company && (
                                    <p className="text-gray-500 text-sm">
                                      <i className="fas fa-building text-sm text-gray-500 "></i>{" "}
                                      {request.company}
                                    </p>
                                  )}
                                </Link>
                              </div>
                              <div className="flex items-center justify-between gap-2">
                                <button
                                  className="flex items-center justify-between gap-1 px-4 py-1 text-gray-600 rounded-full hover:text-gray-700 hover:bg-gray-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                  onClick={() => handleDecline(request.id)}
                                >
                                  Ignore
                                </button>
                                <button
                                  className="flex items-center justify-between gap-1 px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                  onClick={() =>
                                    handleAccept(request.network_id)
                                  }
                                >
                                  Accept
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="w-full h-64 flex items-center justify-center">
                          <p className="text-gray-500 px-[10px]">
                            No new invitations
                          </p>
                        </div>
                      )}
                    </TabPanel>

                    <TabPanel value="2">
                      {sendRequests && sendRequests.length > 0 ? (
                        <div>
                          {sendRequests.map((request, index) => (
                            <div
                              key={index}
                              className="flex justify-between px-4 border-b border-gray-200 "
                            >
                              <div className="flex items-center gap-4 p-2">
                                <Link to={`/user/profile/${request.slug}`}>
                                  {request.profile ? (
                                    <img
                                      src={request.profile}
                                      alt={request.name}
                                      className="w-12 h-12 rounded-full object-cover"
                                    />
                                  ) : (
                                    <div
                                      className="w-12 h-12 rounded-full  text-white flex items-center justify-center font-semibold text-lg"
                                      style={getColorFromName(
                                        request.name || "?"
                                      )}
                                    >
                                      {request.name.charAt(0)}
                                    </div>
                                  )}
                                </Link>
                                <Link
                                  to={`/user/profile/${request.slug}`}
                                  className=""
                                >
                                  <p className="text-gray-800 text-lg font-semibold">
                                    {request.name}
                                  </p>
                                  <p className="text-gray-500">
                                    {request.headline}
                                  </p>
                                  {request.company && (
                                    <p className="text-gray-500 text-sm">
                                      <i className="fas fa-building text-sm text-gray-500 "></i>{" "}
                                      {request.company}
                                    </p>
                                  )}
                                </Link>
                              </div>
                              <div className="flex items-center justify-between gap-2">
                                <button
                                  className="flex items-center justify-between gap-1 px-4 py-1 text-gray-600 rounded-full hover:text-gray-700 hover:bg-gray-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                  onClick={() =>
                                    handleDecline(request.network_id)
                                  }
                                >
                                  withdraw
                                </button>
                                {/* <button
                                  className="flex items-center justify-between gap-1 px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                                  onClick={() =>
                                    handleAccept(request.network_id)
                                  }
                                >
                                  Accept
                                </button> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="w-full h-64 flex items-center justify-center">
                          <p className="text-gray-500 px-[10px]">
                            There is no sent requests.
                          </p>
                        </div>
                      )}
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>

            {/* {recievedRequests ? (
              <div className=" ">
                {recievedRequests.map((request, index) => (
                  <div
                    key={index}
                    className="flex  justify-between px-4 border-b border-gray-200 py-1"
                  >
                    <div className="flex items-center gap-4">
                      <img
                        src={request.profile}
                        alt="Profile picture"
                        className="size-24 rounded-full border-4 border-white"
                      />
                      <div className="">
                        <p className="text-gray-800 text-lg font-semibold">
                          {request.name}
                        </p>
                        <p className="text-gray-500">{request.position}</p>
                        <p className="text-gray-500 text-sm">
                          <i className="fas fa-building text-sm text-gray-500 "></i>{" "}
                          {request.company}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between gap-2">
                      <button
                        className="flex items-center justify-between gap-1 px-4 py-1 text-gray-600 rounded-full hover:text-gray-700  hover:bg-gray-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                        onClick={() => handleDecline(request.id)}
                      >
                        Ignore
                      </button>
                      <button
                        className="flex items-center justify-between gap-1 px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                        onClick={() => handleAccept(request.network_id)}
                      >
                        Accept
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : null} */}
          </div>

          {/* <div className="bg-white p-6 rounded-lg shadow mb-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Recommended for you</h2>
              <Link to="#" className="text-blue-500">
                See all
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {users.map(
                (user, index) =>
                  (user.request_status === null ||
                    user.request_status === 0 ||
                    user.request_status === "pending") && (
                    <div
                      key={index}
                      className="relative bg-white rounded-lg shadow-xl p-6 w-full"
                    >
                      <div className="absolute top-0 right-0 p-4">
                        <i className="fas fa-times text-gray-400"></i>
                      </div>

                      <Link to="/user/profile">
                        <div className="flex flex-col items-center mt-4">
                          <img
                            src={user.profile}
                            alt={`Profile picture of ${user.name}`}
                            className="rounded-full w-24 h-24 object-cover"
                          />
                          <h2 className="mt-4 text-lg font-semibold text-center">
                            {user.name}
                          </h2>
                          <p className="text-gray-500 text-center text-sm">
                            {user.headline}
                          </p>
                          <div className="flex items-center mt-2 gap-2">
                            <i className="fas fa-building text-xl text-gray-500"></i>
                            <p className="text-gray-500 text-sm">
                              {user.position}
                            </p>
                          </div>
                        </div>
                      </Link>

                      <div className="flex justify-center mt-4 space-x-4">
                        {user.request_status === null ||
                        user.request_status === 0 ? (
                          <button
                            className="flex items-center justify-between gap-1 px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85"
                            onClick={() => handleConnect(user.id)}
                          >
                            <span className="text-xl">
                              <TiUserAdd />
                            </span>
                            Connect
                          </button>
                        ) : (
                          <button
                            className="flex items-center justify-between gap-1  px-4 py-1 border border-blue-600 text-blue-600 rounded-full hover:border-2 hover:text-blue-700 hover:border-blue-700 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85 cursor-not-allowed"
                            disabled
                          >
                            <span className="text-xl">
                              <WiTime3 />
                            </span>
                            Pending
                          </button>
                        )}
                      </div>
                    </div>
                  )
              )}
            </div>

            <div className="flex justify-between gap-3 items-center mt-10">
              <h2 className="text-md text-gray-600">
                People who are in the Software Development industry also follow
                these people.
              </h2>
              <Link to="#" className="text-blue-500 min-w-fit">
                See all
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8 mt-4">
              <div className="w-full rounded-lg overflow-hidden shadow-lg bg-white mt-6">
                <div className="relative">
                  <img
                    className="absolute "
                    src="https://placehold.co/600x200"
                    alt="A laptop with a colorful keyboard"
                  />
                  <img
                    className="absolute w-16 h-16 rounded-full ml-4 mt-14"
                    src="https://placehold.co/100x100"
                    alt="Profile picture of the person"
                  />
                  <button className="absolute bg-white text-blue-600 hover:bg-blue-600 hover:text-white border border-blue-600 font-md py-1 px-4 right-4 top-[120px] rounded-full">
                    Follow
                  </button>
                </div>
                <div className="flex flex-col items-center px-6 py-4 ">
                  <div className="text-sm mt-32">
                    <p className="text-gray-900 leading-none text-lg font-bold mb-1.5">
                      Ruhi Varma
                    </p>
                    <p className="text-gray-600">
                      Manager Learning & Development | People Centric | Life
                      Coach | Senior Analyst
                    </p>
                    <p className="text-gray-600 mt-2">
                      Talks about{" "}
                      <span className="text-blue-500">#coaching</span>,{" "}
                      <span className="text-blue-500">#spiritual</span>,{" "}
                      <span className="text-blue-500">#communicationcoach</span>
                      ,{" "}
                      <span className="text-blue-500">#communicationskill</span>
                    </p>
                    <p className="text-gray-600 mt-2">510 followers</p>
                  </div>
                </div>
              </div>

              <div className="w-full rounded-lg overflow-hidden shadow-lg bg-white mt-6">
                <div className="relative">
                  <img
                    className="absolute "
                    src="https://placehold.co/600x200"
                    alt="A laptop with a colorful keyboard"
                  />
                  <img
                    className="absolute w-16 h-16 rounded-full ml-4 mt-14"
                    src="https://placehold.co/100x100"
                    alt="Profile picture of the person"
                  />
                  <button className="absolute bg-white text-blue-600 hover:bg-blue-600 hover:text-white border border-blue-600 font-md py-1 px-4 right-4 top-[120px] rounded-full">
                    Follow
                  </button>
                </div>
                <div className="flex flex-col items-center px-6 py-4 ">
                  <div className="text-sm mt-32">
                    <p className="text-gray-900 leading-none text-lg font-bold mb-1.5">
                      Ruhi Varma
                    </p>
                    <p className="text-gray-600">
                      Manager Learning & Development | People Centric | Life
                      Coach | Senior Analyst
                    </p>
                    <p className="text-gray-600 mt-2">
                      Talks about{" "}
                      <span className="text-blue-500">#coaching</span>,{" "}
                      <span className="text-blue-500">#spiritual</span>,{" "}
                      <span className="text-blue-500">#communicationcoach</span>
                      ,{" "}
                      <span className="text-blue-500">#communicationskill</span>
                    </p>
                    <p className="text-gray-600 mt-2">510 followers</p>
                  </div>
                </div>
              </div>

              <div className="w-full rounded-lg overflow-hidden shadow-lg bg-white mt-6">
                <div className="relative">
                  <img
                    className="absolute "
                    src="https://placehold.co/600x200"
                    alt="A laptop with a colorful keyboard"
                  />
                  <img
                    className="absolute w-16 h-16 rounded-full ml-4 mt-14"
                    src="https://placehold.co/100x100"
                    alt="Profile picture of the person"
                  />
                  <button className="absolute bg-white text-blue-600 hover:bg-blue-600 hover:text-white border border-blue-600 font-md py-1 px-4 right-4 top-[120px] rounded-full">
                    Follow
                  </button>
                </div>
                <div className="flex flex-col items-center px-6 py-4 ">
                  <div className="text-sm mt-32">
                    <p className="text-gray-900 leading-none text-lg font-bold mb-1.5">
                      Ruhi Varma
                    </p>
                    <p className="text-gray-600">
                      Manager Learning & Development | People Centric | Life
                      Coach | Senior Analyst
                    </p>
                    <p className="text-gray-600 mt-2">
                      Talks about{" "}
                      <span className="text-blue-500">#coaching</span>,{" "}
                      <span className="text-blue-500">#spiritual</span>,{" "}
                      <span className="text-blue-500">#communicationcoach</span>
                      ,{" "}
                      <span className="text-blue-500">#communicationskill</span>
                    </p>
                    <p className="text-gray-600 mt-2">510 followers</p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="w-full lg:w-1/4 ">
          <img
            src="https://placehold.co/200x200"
            alt="Profile picture"
            className="w-full h-48 object-cover rounded-t-lg"
          />
          <div className=" text-center py-4 mt-8  border-t border-gray-300">
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-4">
              <Link to="#" className="hover:underline">
                About
              </Link>
              <Link to="#" className="hover:underline">
                Help Center
              </Link>
              <Link to="#" className="hover:underline">
                Privacy & Terms
              </Link>
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
              <Link to="#" className="hover:underline">
                Ad Choices
              </Link>
              <i className="fas fa-caret-down"></i>
              <Link to="#" className="hover:underline">
                Ad Choices
              </Link>
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
              <Link to="#" className="hover:underline">
                Advertising
              </Link>
              <Link to="#" className="hover:underline">
                Business Services
              </Link>
              <i className="fas fa-caret-down"></i>
            </div>
            <div className="flex flex-wrap justify-center space-x-4 text-sm text-gray-600 mt-2">
              <Link to="#" className="hover:underline">
                Get the LinkedIn app
              </Link>
              <Link to="#" className="hover:underline">
                More
              </Link>
            </div>
            <div className="flex flex-wrap justify-center items-center mt-4">
              <img
                src="/Images/logo/ls-linked-logo.png"
                alt="LinkedIn logo"
                className="mr-2"
              />
              <span className="text-sm text-gray-600">
                LS-LinkedIn Corporation © 2025
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageInvitations;
